import HallOverviewFilterModal from "./hall-overview-filter-modal";

import "./hall-modals.scss";


const HallModals = {
    FilterModal : HallOverviewFilterModal
};

export default HallModals;